(function () {
  'use strict';

  function setButtonLoading(form, isLoading) {
    const button = form.querySelector('button[name="add"]');
    const spinner = form.querySelector('.loading__spinner');
    if (!button) return;

    if (isLoading) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      spinner?.classList.remove('hidden');
      return;
    }

    button.classList.remove('loading');
    button.removeAttribute('aria-disabled');
    spinner?.classList.add('hidden');
  }

  async function submitProductForm(form) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.routes?.cart_add_url) return;
    const completeCartUpdate = window.RakuzanCartUpdates?.begin?.() || (() => {});

    const formData = new FormData(form);
    formData.append(
      'sections',
      drawer
        .getSectionsToRender()
        .map((section) => section.id)
        .join(',')
    );
    formData.append('sections_url', window.location.pathname);

    drawer.setActiveElement(document.activeElement);
    setButtonLoading(form, true);

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        body: formData,
      });
      const data = await response.json();

      if (data.status) return;

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'rakuzan-cart-drawer',
          productVariantId: formData.get('id'),
          cartData: data,
        });
      }

      drawer.renderContents(data);
    } catch (error) {
      console.error(error);
    } finally {
      completeCartUpdate();
      setButtonLoading(form, false);
    }
  }

  function setCartLinkPending(link, isPending) {
    link.classList.toggle('is-pending', isPending);
    link.setAttribute('aria-busy', String(isPending));
    link.setAttribute('aria-disabled', String(isPending));
  }

  async function handleCartLinkClick(event) {
    const link = event.target.closest('cart-drawer .rakuzan-cart-drawer__cart-link');
    if (!(link instanceof HTMLAnchorElement)) return;
    if (!window.RakuzanCartUpdates?.isPending?.()) return;

    event.preventDefault();
    event.stopPropagation();

    if (link.dataset.rzNavigating === 'true') return;

    link.dataset.rzNavigating = 'true';
    setCartLinkPending(link, true);

    try {
      await window.RakuzanCartUpdates.wait();
    } finally {
      window.location.href = link.href;
    }
  }

  function handleDrawerSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.dataset.type !== 'add-to-cart-form') return;
    if (!document.querySelector('cart-drawer')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    submitProductForm(form);
  }

  function handleDrawerButtonClick(event) {
    const button = event.target.closest('button[name="add"]');
    if (!(button instanceof HTMLButtonElement)) return;
    const form = button.closest('form[data-type="add-to-cart-form"]');
    if (!(form instanceof HTMLFormElement)) return;
    if (!document.querySelector('cart-drawer')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    submitProductForm(form);
  }

  window.RakuzanCartDrawer = {
    add(button) {
      const form = button?.closest('form[data-type="add-to-cart-form"]');
      if (!(form instanceof HTMLFormElement)) return;
      submitProductForm(form);
    },
  };

  document.addEventListener('submit', handleDrawerSubmit, true);
  document.addEventListener('click', handleDrawerButtonClick, true);
  document.addEventListener('click', handleCartLinkClick, true);
})();
